// Store Configuration
import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';

import { authTokenSyncMiddleware } from './middleware/authTokenSync';
import {
  adminAuthReducer,
  authReducer,
  bookmarksReducer,
  comboSelectionReducer,
  searchReducer,
  sportsReducer,
  uiReducer,
} from './slices';

export const store = configureStore({
  reducer: {
    adminAuth: adminAuthReducer,
    auth: authReducer,
    bookmarks: bookmarksReducer,
    comboSelection: comboSelectionReducer,
    ui: uiReducer,
    sports: sportsReducer,
    search: searchReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }).concat(authTokenSyncMiddleware),
  devTools: process.env.NODE_ENV !== 'production',
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export * from './slices';
